import axios from "axios";

const Axios = axios.create({
  baseURL: "https://api.explorer.sentinel.co/v2/statistics",
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    skip: 0,
    from_timestamp: "2023-01-01T00:00:00.000Z",
    to_timestamp: "2050-01-01T00:00:00.000Z",
  },
});

export default Axios;
